import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import Iconify from "../../components/iconify/Iconify";

function CancelKOTConfirmDialog({ open, onClose, onCancel }) {
  const [reason, setReason] = useState("");
  const [customReason, setCustomReason] = useState("");

  const reasons = [
    "Customer no-show",
    "Customer changed mind",
    "Duplicate order",
    "Mistaken order",
    "Out of stock / unavailable",
    "Other",
  ];

  useEffect(() => {
    if (!open) {
      setReason("");
      setCustomReason("");
    }
  }, [open]);

  const isValid =
    reason && (reason !== "Other" || customReason.trim().length >= 3);

  const handleConfirm = () => {
    const finalReason = reason === "Other" ? customReason : reason;
    onCancel(finalReason);
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reasons) => {
        if (reasons !== "backdropClick") {
          onClose();
        }
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <Iconify icon="mdi:alert-circle-outline" width={22} color="#d32f2f" />
          <Typography variant="h6" fontWeight={600}>
            Cancel KOT
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Please select a reason for cancelling this Kitchen Order Ticket.
          <br />
          <strong>This action cannot be undone.</strong>
        </Typography>

        {/* Reason Dropdown */}
        <TextField
          select
          fullWidth
          label="Cancellation Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          margin="dense"
        >
          {reasons.map((r) => (
            <MenuItem key={r} value={r}>
              {r}
            </MenuItem>
          ))}
        </TextField>

        {/* Custom Reason */}
        {reason === "Other" && (
          <TextField
            fullWidth
            label="Enter custom reason"
            autoComplete="off"
            value={customReason}
            onChange={(e) => setCustomReason(e.target.value)}
            margin="dense"
            autoFocus
            placeholder="Minimum 3 characters"
          />
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined">
          Keep KOT
        </Button>

        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={!isValid}
          startIcon={<Iconify icon="mdi:close-circle-outline" />}
        >
          Cancel KOT
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CancelKOTConfirmDialog;
